import styles from './ProductList.module.scss';
import Header from '../../components/Header/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import product01 from '../../assets/imsi/imsiProduct1.png';
import Footer from '../../components/Footer/Footer';
import { useQuery } from 'react-query';
import axiosClient from '../../libs/axiosClient';
import { useTranslation } from 'react-i18next';
import gambicha from "../../assets/gambicha.png";
import biumwhan from "../../assets/biumwhan.png";
import cheongdambogam from "../../assets/cheongdambogam.png";
import cheongdambogamRenewal from "../../assets/banner/dietProgramBanner.png";

export interface IProductListType {
  is_prescription: number; //0: 건강식품, 1:처방의약품
  blind_code: string;
  id: string;
  product_id: number;
  category_id: number;
  list_image: string;
  image: string;
  detail_url: string;
  discount_rate: number;
  title: string;
  price: number;
  soldout: string;
  discount_price: number;
  brand_name: string | null;
  hashtag: string;
  hospital_name: string | null;
  review_score_avg: {
    review_point_0_avg: number;
    review_point_1_avg: number;
    review_point_2_avg: number;
    review_point_3_avg: number;
    review_point_total_avg: number;
    review_total_count: number;
  };
  is_like: number;
}

function ProductList() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const cuid = new URLSearchParams(location.search).get('cuid');
  const tab = cuid === '488' ? 'supplement' : 'prescription';

  const { data: productList } = useQuery<IProductListType[]>(
    ['productList', 'all'],
    async () => {
      let queryString = '';
      let ids = JSON.parse(sessionStorage.getItem('product_ids') || JSON.stringify([]));
      if (ids.length) {
        queryString = 'add_products=';
        ids.map((id: number, idx: number) => {
          queryString += `${id}${idx !== ids.length - 1 ? ',' : ''}`;
        });
      }
      return await axiosClient
        .get(`/data/product/list?${queryString}`)
        .then((res) => res.data.data);
    },
    {
      staleTime: 60000 * 60 * 24,
    },
  );

  const productInfo = [
    {
      url: cheongdambogam,
      description: "A healthy diet in which you can succeed at once."
    },
    {
      url: biumwhan,
      description: "Empower your everyday with natural vitality.",
    },
    {
      url: cheongdambogam,
      description: "A healthy diet in which you can succeed at once.",
    }
  ];
  
  const productInfoMap: Record<
    number,
    { url: string; description: string; title: string }
  > = {
    32: {
      url: cheongdambogam,
      title: 'Cheongdam Bogam Diet tablet',
      description: 'A healthy diet in which you can succeed at once.',
    },
    45: {
      url: cheongdambogamRenewal,
      title: 'Cheongdam Bogam Diet tablet Renewal',
      description: 'A healthy diet in which you can succeed at once.',
    },
    10: {
      url: biumwhan,
      title: 'Cheongdam Bogam Bium Hwan',
      description: 'Empower your everyday with natural vitality.',
    },
    11: {
      url: gambicha,
      title: 'Cheongdam Bogam Gambi Tea',
      description: "Cleanse your daily life gently with nature’s finest ingredients.",
    },
  };
  
  const PRESCRIPTION_IDS = [32, 45];
  const SUPPLEMENT_IDS   = [10, 11];

  const filteredList =
    (productList || [])
      .filter(p =>
        tab === 'prescription'
          ? PRESCRIPTION_IDS.includes(p.product_id)
          : SUPPLEMENT_IDS.includes(p.product_id)
      )
      .sort((a, b) => {
        const order = tab === 'prescription' ? PRESCRIPTION_IDS : SUPPLEMENT_IDS;
        return order.indexOf(a.product_id) - order.indexOf(b.product_id);
      });

  return (
    <div>
      <Header />
      <div className={styles.categorySelectWrap}>
        <h3>{t('productList.1')}</h3>
        <ul className={styles.categoryList}>
          <li
            className={tab === 'prescription' ? styles.hit : ''}
            onClick={() => navigate('/productList?cuid=487')}
          >
            {t('productList.2')}
          </li>
          <li
            className={tab === 'supplement' ? styles.hit : ''}
            onClick={() => navigate('/productList?cuid=488')}
          >
            {t('productList.3')}
          </li>
        </ul>
        <ul className={styles.productList}>
          {filteredList.length > 0 ? (
            filteredList.map((product, idx) => (
              <li
                key={product.product_id}
                className={styles.productCard}
                onClick={() => navigate(`/productDetail/${product.product_id}`)}
              >
                <div
                  className={styles.backgroundImage}
                  style={{
                    backgroundImage: `url(${
                      productInfoMap[product.product_id]?.url ||
                      (product.is_prescription === 1
                        ? cheongdambogam
                        : product.title.includes('비움환')
                        ? biumwhan
                        : product.title.includes('감비차')
                        ? gambicha
                        : '')
                    })`,
                  }}
                >
                  <div className={styles.infoBox}>
                    <div className={styles.thumbnailBox}>
                      <img
                        src={product.list_image}
                        alt="product thumbnail"
                        className={styles.thumbnailImage}
                      />
                    </div>
                    <div className={styles.textInfo}>
                      <span className={styles.productName}>
                        {productInfoMap[product.product_id]?.title || product.title}
                      </span>
                      <span className={styles.price}>
                        ${product.discount_price.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </div>
                <div className={styles.descriptionWrap}>
                  <p className={styles.description}>
                    {productInfoMap[product.product_id]?.description ||
                      (product.is_prescription === 1
                        ? 'A healthy diet in which you can succeed at once.'
                        : product.title.includes('비움환')
                        ? 'Empower your everyday with natural vitality.'
                        : product.title.includes('감비차')
                        ? "Cleanse your daily life gently with nature’s finest ingredients."
                        : ''
                      )
                    }
                  </p>
                  <div className={styles.buttonGroup}>
                    <button className={styles.shopNow}>Shop Now</button>
                  </div>
                </div>
              </li>
            ))
          ) : (
            <li className={`${styles.productCard} ${styles.comingSoonCard}`}>
              <div className={styles.backgroundImage}>
                <div className={styles.comingSoonBox}>
                  <p className={styles.comingSoonText}>COMING SOON!</p>
                </div>
              </div>
              <div className={styles.descriptionWrap}>
                <p className={styles.description} />
                <div className={styles.buttonGroup}>
                  <button className={`${styles.shopNow} ${styles.disabled}`} disabled>
                    Shop Now
                  </button>
                </div>
              </div>
            </li>
          )}
        </ul>
      </div>
      <Footer />
    </div>
  );
}
export default ProductList;
